module.exports = __webpack_public_path__ + "img/yy-s6.93dcecc7.svg";